export default __webpack_public_path__ + "static/G-SYNC-Ultimate-ccd95bf2114f60da8e5aba385a2e28e5.webp";